<template>
  <v-app>
    <v-system-bar app :color="this.$store.getters.stdColorLight">
      <v-spacer></v-spacer>
      <v-icon :color="this.$store.getters.systemBarColor">perm_identity</v-icon>
      <span>{{ this.$store.getters.username }}</span>
    </v-system-bar>

    <v-app-bar app :color="this.$store.getters.stdColorLight">
      <v-app-bar-nav-icon @click="toggleDrawer()"></v-app-bar-nav-icon>
      <v-toolbar-title>{{ $t("message.optimaw2") }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <optima-help></optima-help>
      <v-menu
        v-model="value"
        :disabled="disabled"
        :absolute="absolute"
        :open-on-hover="openOnHover"
        :close-on-click="closeOnClick"
        :close-on-content-click="closeOnContentClick"
        :offset-x="offsetX"
        :offset-y="offsetY"
      >
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item :disabled="this.$store.getters.isLoggedOn" @click="handleLogon()">
            <v-list-item-title class="subtitle-2">{{ $t("message.anmelden") }}</v-list-item-title>
          </v-list-item>
          <v-list-item :disabled="!this.$store.getters.isLoggedOn" @click="handleLogon()">
            <v-list-item-title class="subtitle-2">{{ $t("message.abmelden") }}</v-list-item-title>
          </v-list-item>
          <v-divider :inset="inset"></v-divider>
          <v-list-item
            v-for="(lang, index) in langs"
            :key="index"
            v-on:click="handleLanguage(lang.locale)"
          >
            <v-list-item-title class="subtitle-2">{{ lang.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <optima-navigation-drawer v-if="this.$store.getters.isLoggedOn"></optima-navigation-drawer>

    <v-main>
      <router-view :name="this.$store.getters.routerViewContent"></router-view>
    </v-main>
  </v-app>
</template>

<script>
import OptimaHelp from "@/components/OptimaHelp";
import EntityHelper from "@/plugins/EntityHelper";
import OptimaNavigationDrawer from "@/components/OptimaNavigationDrawer";

export default {
  name: "App",

  components: {
    OptimaNavigationDrawer,
    OptimaHelp
  },

  data: () => ({
    //languages, menu
    langs: [
      { locale: "de", title: "deutsch" },
      { locale: "fr", title: "französisch" },
      { locale: "en", title: "englisch" }
    ],
    disabled: false,
    absolute: false,
    openOnHover: false,
    value: false,
    closeOnClick: true,
    closeOnContentClick: true,
    offsetX: false,
    offsetY: true,
    inset: false,

    drawerClipped: true,
    drawerFixed: false,
    drawerMini: false,

    entityHelper: null
  }),

  computed: {
    drawer: {
      get() {
        return this.$store.state.navigationDrawer.drawer;
      },

      set(value) {
        this.$store.dispatch("setNavigationDrawer", value);
      }
    }
  },

  created() {
    this.entityHelper = new EntityHelper(this);
  },

  mounted() {
    this.$store.dispatch("setSelectedLanguage", this.$root.$i18n.locale);
    this.moveableDialogs();
  },

  methods: {
    // toggle the drawer state to open or close it
    toggleDrawer() {
      this.drawer = !this.drawer;
    },

    handleLanguage: function(aLocale) {
      this.$root.$i18n.locale = aLocale;
      //force watch to be executed
      this.$store.dispatch("setSelectedLanguage", aLocale);
    },

    handleLogon: function() {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setActualUser", { username: "", password: "" });
      this.entityHelper.clearMasterDataState();

      this.$store.dispatch(
        "setSystemBarColor",
        this.$store.getters.colorSystemBarOff
      );
      this.$store.dispatch("setLoggedOn", false);
    },

    //hack from https://github.com/vuetifyjs/vuetify/issues/4058
    moveableDialogs() {
      const d = {};
      document.addEventListener("mousedown", e => {
        const closestDialog = e.target.closest(".v-dialog.v-dialog--active");
        if (
          e.button === 0 &&
          closestDialog != null &&
          e.target.classList.contains("v-card__title")
        ) {
          // element which can be used to move element
          d.el = closestDialog; // element which should be moved
          d.mouseStartX = e.clientX;
          d.mouseStartY = e.clientY;
          d.elStartX = d.el.getBoundingClientRect().left;
          d.elStartY = d.el.getBoundingClientRect().top;
          d.el.style.position = "fixed";
          d.el.style.margin = 0;
          d.oldTransition = d.el.style.transition;
          d.el.style.transition = "none";
        }
      });
      document.addEventListener("mousemove", e => {
        if (d.el === undefined) return;
        d.el.style.left =
          Math.min(
            Math.max(d.elStartX + e.clientX - d.mouseStartX, 0),
            window.innerWidth - d.el.getBoundingClientRect().width
          ) + "px";
        d.el.style.top =
          Math.min(
            Math.max(d.elStartY + e.clientY - d.mouseStartY, 0),
            window.innerHeight - d.el.getBoundingClientRect().height
          ) + "px";
      });
      document.addEventListener("mouseup", () => {
        if (d.el === undefined) return;
        d.el.style.transition = d.oldTransition;
        d.el = undefined;
      });
      setInterval(() => {
        // prevent out of bounds
        const dialog = document.querySelector(".v-dialog.v-dialog--active");
        if (dialog === null) return;
        dialog.style.left =
          Math.min(
            parseInt(dialog.style.left),
            window.innerWidth - dialog.getBoundingClientRect().width
          ) + "px";
        dialog.style.top =
          Math.min(
            parseInt(dialog.style.top),
            window.innerHeight - dialog.getBoundingClientRect().height
          ) + "px";
      }, 100);
    }
  }
};
</script>
<style>
</style>
